import React from 'react';
import Header from '../../../components/header';
import MissionVission from './mission-vission';

import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';

const WhoWeAre = () => {
  const { translations } = useLanguage();
  return (
    <div className="whoweare-container">
      <Header title={translations.about.whoWeAre} flip={true} bgImg="/assets/images/header-bg/bg_whoWeAre2.jpg" />
      <section className="bg-white text-black space-y-12">
        <div className="flex flex-col space-y-8 justify-center items-start mx-auto">
          <div>
            <h2 className="text-[#28357B] text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.whoWeAreTitle)} />
          </div>
          <div className="space-y-2 md:max-w-[80%]">
            <p className="text-md mb-4" dangerouslySetInnerHTML={renderHTML(translations.about.whoWeAreSubtitle)} />
            <p className="text-md" dangerouslySetInnerHTML={renderHTML(translations.about.whoWeAreDesc)} />
          </div>
        </div>
      </section>
      <div className="w-full h-[35vh] md:h-[45vh] flex">
        <img
          src="/assets/images/SELGEM-37_compress.jpg"
          alt="Our Team"
          className="w-1/2 h-full object-cover"
        />
        <img
          src="/assets/images/section-img/townhall_group.jpg"
          alt="Board Member"
          className="w-1/2 h-full object-cover"
        />
      </div>
      <MissionVission />
      <div className="bg-white w-full">
        <div className="h-screen">
          <img src="/assets/images/section-img/section_missionVision.jpg" alt="Board" className="object-cover h-screen w-full" />
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
